import { hasVersion, stripVersion } from './versions';

function cleanServiceClassname(key: string | undefined, size: string) {
  if (!key) {
    return key;
  }

  const className = hasVersion(key) ? stripVersion(key) : key;

  return className.includes(size) ? className : `${className}${size}`;
}

export default cleanServiceClassname;
